import { useTranslation } from "react-i18next";
import { BrowserRouter } from "react-router-dom";

import Router from "./routes";

function App() {
  const { i18n } = useTranslation();

  // document.dir = i18n.dir();
  document.body.style.fontFamily =
    i18n.dir() === "ltr" ? "Poppins, sans-serif" : "Tajawal, sans-serif";

  
  return (
    <div className="App">
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </div>
  );
}

export default App;
